export class CostCenterReportFilter {
  startDateTime: string;
  endDateTime: string;
  customerHashId: string = "";
  instanceHashId: string = "";
  companyHashId: string = "";
  organizationHashId: string = "";
  costTypeHashId: string = "";
  isShowTotal: boolean;
  vehicleHashIdList: string[] = [];
  driverHashIdList: string[] = [];
  searchLicenceTagList: string[] = [];
  searchDriverNameList: string[] = [];
  costTypeHashIdList: string[] = [];
  searchCostTypeNameList: string[] = [];
  showTotalOnly: boolean = false;
}

export class DropdownModel {
  keyHash: string;
  value: string;
  data: any;
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/report/models/report-filter-cost-center.model.ts